<h1 class="ap-blue">{{'ml_151063' | translate}}</h1>

<mat-card class="mt-3 mb-3">
  <app-message-data [errorMsg$]="errorMessage$" [infoMsg$]="successMessage$"></app-message-data>

  <mat-card-content>
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_151066' | translate}}</mat-label>
            <input matInput placeholder="{{'ml_151066' | translate}}" formControlName="hackApexID" />
          </mat-form-field>
        </div>
        <div class="col">
          <spinner-button [refreshState$]="getUserProfileMeProcessing$" [disabled]="editForm.invalid || !this.editForm.controls['hackApexID'].value || this.editForm.controls['hackApexID'].value===''" label="{{ 'ml_151066' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
            (clicked)="onSetHackApexID()">
          </spinner-button>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_151064' | translate}}</mat-label>
            <mat-select formControlName="invokeCommands" [disabled]="commandInvokeProcessing$ | async" multiple>
              @for (item of jobSelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <spinner-button [refreshState$]="commandInvokeProcessing$"
            [disabled]="editForm.invalid || !this.editForm.controls['invokeCommands'].value || this.editForm.controls['invokeCommands'].value.length === 0" label="{{ 'ml_151065' | translate }}"
            refreshLabel="{{ 'ml_143923' | translate }}" (clicked)="onEDLJobStart()">
          </spinner-button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
